import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77386bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "viewQuestionView" }
const _hoisted_2 = { id: "leftPart" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

import {
  onBeforeMount,
  onMounted,
  ref,
  watch,
  watchEffect,
  withDefaults,
} from "vue";
import message from "@arco-design/web-vue/es/message";
import CodeEditor from "@/components/CodeEditor.vue";
import MDViewer from "@/components/MDViewer.vue";
import JudgeInfoMessageEnum from "@/enums/JudgeInfoMessageEnum";
import moment from "moment/moment";
import { Codemirror } from "vue-codemirror";
import { oneDark } from "@codemirror/theme-one-dark";
import { cpp } from "@codemirror/lang-cpp";
import java from "@codemirror/lang-java";
import { QuestionSubmitControllerService } from "../../../generated/services/QuestionSubmitControllerService";
import { QuestionSubmitQueryRequest } from "../../../generated/models/QuestionSubmitQueryRequest";
import { QuestionVO } from "../../../generated/models/QuestionVO";
import { QuestionSubmitAddRequest } from "../../../generated/models/QuestionSubmitAddRequest";
import { QuestionControllerService } from "../../../generated/services/QuestionControllerService";
import { QuestionCollectControllerService } from "../../../generated/services/QuestionCollectControllerService";
import { useStore } from "vuex";
import { QuestionCommentControllerService } from "../../../generated/services/QuestionCommentControllerService";
import { QuestionComment } from "../../../generated/models/QuestionComment";
import { Message } from "@arco-design/web-vue";
import { CommentReportControllerService } from "../../../generated/services/CommentReportControllerService";
import { useRoute, useRouter } from "vue-router";
import { QuestionSolutionControllerService } from "../../../generated/services/QuestionSolutionControllerService";
import MDEditor from "@/components/MDEditor.vue";

interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewQuestionView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

const router = useRouter();
const route = useRoute();

// 获取题目id
const props = __props;

// Tab栏默认tab
const activeKey = ref("question");

// 获取登录用户
const store = useStore();
let loginUser = store.state.user.loginUser;

const resizeBoxWidth = ref(755);
const codeWidth = ref(0);

watchEffect(() => {
  codeWidth.value = window.innerWidth - resizeBoxWidth.value;
});
window.addEventListener("resize", () => {
  // 窗口大小改变时,手动触发更新
  codeWidth.value = window.innerWidth - resizeBoxWidth.value;
});

// 提交记录详情页面是否可见
const historyVisible = ref(false);
// 提交记录
const historyRecord = ref({});
// 自测运行代码是否正在运行
const runLoading = ref(false);
// 控制台是否可见
const consoleVisible = ref(false);
// CodeMirror的一些配置
const extensions = [cpp(), oneDark];
// 自测运行代码的请求负载
const runCodeRequest = ref({ input: "" });
// 自测运行代码的请求响应
const runCodeResponse = ref({ output: "", message: "" });

/**
 * 点击按钮打开控制台
 */
const handleConsoleClick = () => {
  consoleVisible.value = true;
};

/**
 * 自测运行代码
 */
const handleRunClick = async () => {
  runLoading.value = true;
  const res = await QuestionSubmitControllerService.questionRunOnlineUsingPost({
    input: runCodeRequest.value.input,
    code: form.value.code,
    language: form.value.language,
  });
  if (res.code === 0) {
    runCodeResponse.value.output = res.data.output
      ? res.data.output
      : res.data.message;
  }
  runLoading.value = false;
};

/**
 * 关闭控制台
 */
const handleConsoleClose = () => {
  consoleVisible.value = false;
};

/**
 * 点击单条提交记录时的处理
 * @param value
 */
const handleHistoryRecordClick = (value: any) => {
  historyVisible.value = true;
  historyRecord.value = value;
};

// 查询个人提交记录的参数
const questionSubmitSearchParams = ref<QuestionSubmitQueryRequest>({
  language: undefined,
  questionId: undefined,
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "descend",
});
// 个人提交记录总数
const total = ref(0);
// 个人提交记录
const dataList = ref([]);
// 个人提交记录需要展示的列
const columns = [
  {
    title: "判题结果",
    slotName: "message",
    align: "center",
    width: 100,
  },
  {
    title: "提交时间",
    slotName: "createTime",
    align: "center",
  },
  {
    title: "编程语言",
    dataIndex: "language",
    align: "center",
  },
  {
    title: "执行用时",
    slotName: "time",
    align: "center",
    width: 100,
  },
  {
    title: "消耗内存",
    slotName: "memory",
    align: "center",
    width: 100,
  },
];
// 题目
const question = ref<QuestionVO>({
  acceptedNum: 0,
  answer: "",
  comments: 0,
  content: "",
  createTime: "",
  difficulty: 0,
  id: 0,
  isAccepted: 1,
  judgeConfig: {},
  likes: 0,
  submitNum: 0,
  tags: [],
  title: "",
  updateTime: "",
  userId: 0,
  userVO: {},
});

// 提交代码时的请求负载
const form = ref<QuestionSubmitAddRequest>({
  language: "java",
  code: "",
  questionId: -1,
});

// 支持语言
const languages = ref<string[]>();

// 题单
const questionList = ref([]);
const questionListTotal = ref(0);
const questionListSearchParams = ref({
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  title: "",
  userId: loginUser.id,
});
const isCollect = ref(false);

// 弹窗
const questionListVisible = ref(false);
const addQuestionSolutionVisible = ref(false);
// 打开弹窗
const openQuestionListModal = () => {
  questionListVisible.value = true;
};
const openAddQuestionSolutionModal = () => {
  addQuestionSolutionVisible.value = true;
};
// 关闭弹窗
const closeQuestionListModal = () => {
  questionListVisible.value = false;
};
const closeAddQuestionSolutionModal = () => {
  addQuestionSolutionVisible.value = false;
};

// 评论
const comments = ref([]);
const commentNum = ref(0);
const firstCommentNum = ref(0);
const commentsSearchParams = ref({
  current: 1,
  pageSize: 10,
  questionId: props.id,
  sortField: "createTime",
  sortOrder: "ascend",
});
const replyContent = ref("");
const firstReplyContent = ref("");
const secondReplyContent = ref("");

// 题解
// 用来控制展示题解列表还是具体的题解
const showQuestionSolutionList = ref(true);
const questionSolutionList = ref([]);
const questionSolutionListTotal = ref(0);
const questionSolutionListSearchParams = ref({
  pageSize: 3,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  questionId: props.id,
  title: "",
  tags: [],
});
// 创建题解
const addQuestionSolutionForm = ref({
  questionId: props.id,
  title: "",
  content: "",
  tags: [],
});

/**
 * 题解内容改变函数
 * @param value
 */
const onContentChange = (value: string) => {
  addQuestionSolutionForm.value.content = value;
};

/**
 * 获取题目
 */
const getQuestionByQuestionId = async () => {
  const res = await QuestionControllerService.getQuestionVoByIdUsingGet(
    props.id as any
  );
  if (res.code === 0) {
    question.value = res.data;
    document.title = res.data?.title as string;
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 * 获取个人提交记录
 */
const getPersonalQuestionSubmitByQuestionId = async () => {
  const res =
    await QuestionSubmitControllerService.listMyQuestionSubmitByPageUsingPost({
      ...questionSubmitSearchParams.value,
      questionId: props.id as any,
    });
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 * 监听函数所使用的变量的变化，改变时触发页面的重新加载
 */
watchEffect(async () => {
  await getQuestionByQuestionId();
});
watchEffect(async () => {
  await getPersonalQuestionSubmitByQuestionId();
});
watch(
  questionSolutionListSearchParams,
  () => {
    getQuestionSolutionList();
  },
  { deep: true }
);
watch(
  questionListSearchParams,
  () => {
    getQuestionCollectByUserAllQuestionListDetail();
  },
  { deep: true }
);

/**
 * 在跳转到一个路由之前进行判断
 */
onBeforeMount(() => {
  if (route.fullPath.includes("answers")) {
    activeKey.value = "answers";
  } else if (route.fullPath.includes("solution")) {
    showQuestionSolutionList.value = false;
    activeKey.value = "answers";
  }
});

onMounted(async () => {
  await getQuestionByQuestionId();
  await getPersonalQuestionSubmitByQuestionId();
  await getLanguage();
  await getQuestionCollectByUserAllQuestionListDetail();
  await getComments();
  await getQuestionSolutionList();
});

/**
 * 从后端获取支持语言
 */
const getLanguage = async () => {
  // 从后端获取支持语言
  const res = await QuestionControllerService.getCodeLanguageUsingGet();
  if (res.code === 0) {
    languages.value = res.data;
  }
};

/**
 * 提交代码
 * @constructor
 */
const doQuestionSubmit = async () => {
  if (!question.value?.id) {
    return;
  }
  const res = await QuestionSubmitControllerService.doQuestionSubmitUsingPost({
    ...form.value,
    questionId: question.value?.id,
  });
  if (res.code === 0) {
    message.success("提交成功");
  } else {
    message.error("提交失败，" + res.message);
  }
};

/**
 * 代码编辑器内容切换
 * @param value
 */
const onCodeChange = (value: string) => {
  form.value.code = value;
};

/**
 * 页面切换
 * @param page
 */
const onQuestionSubmitPageChange = (page: number) => {
  questionSubmitSearchParams.value = {
    ...questionSubmitSearchParams.value,
    current: page,
  };
};
const onQuestionListPageChange = (page: number) => {
  questionListSearchParams.value = {
    ...questionListSearchParams.value,
    current: page,
  };
};
const onCommentsPageChange = async (page: number) => {
  commentsSearchParams.value = {
    ...commentsSearchParams.value,
    current: page,
  };
  await getComments();
};
const onQuestionSolutionListPageChange = (page: number) => {
  questionSolutionListSearchParams.value = {
    ...questionSolutionListSearchParams.value,
    current: page,
  };
  getQuestionSolutionList();
};

/**
 * 页面大小切换
 * @param size
 */
const onQuestionSubmitPageSizeChange = (size: number) => {
  questionSubmitSearchParams.value = {
    ...questionSubmitSearchParams.value,
    pageSize: size,
  };
};
const onQuestionListPageSizeChange = (size: number) => {
  questionListSearchParams.value = {
    ...questionListSearchParams.value,
    pageSize: size,
  };
};
const onCommentsPageSizeChange = async (size: number) => {
  commentsSearchParams.value = {
    ...commentsSearchParams.value,
    pageSize: size,
  };
  await getComments();
};
const onQuestionSolutionListPageSizeChange = (size: number) => {
  questionSolutionListSearchParams.value = {
    ...questionSolutionListSearchParams.value,
    pageSize: size,
  };
  getQuestionSolutionList();
};

/**
 * 获取用户所有题单对某道题目的收藏情况
 */
const getQuestionCollectByUserAllQuestionListDetail = async () => {
  const res =
    await QuestionCollectControllerService.isQuestionCollectedByUserAllQuestionListUsingPost(
      props.id as any,
      questionListSearchParams.value
    );
  if (res.code == 0) {
    questionList.value = res.data.questionListVOPage.records;
    questionListTotal.value = res.data.questionListVOPage.total;
    isCollect.value = res.data.isCollect;
    console.log(isCollect.value);
  } else {
    message.error(res.message);
  }
};

/**
 * 收藏题目
 * @param questionListId
 */
const collectQuestion = async (questionListId: number) => {
  const res =
    await QuestionCollectControllerService.addQuestionCollectUsingPost({
      questionId: props.id as any,
      questionListId: questionListId,
    });
  if (res.code == 0) {
    await getQuestionCollectByUserAllQuestionListDetail();
    message.success("收藏成功");
  } else {
    message.error("收藏失败");
  }
};

/**
 * 点赞题目
 */
const likeQuestion = async () => {
  const res = await QuestionControllerService.likeQuestionUsingPost(props.id);
  if (res.code == 0) {
    await getQuestionByQuestionId();
  } else {
    Message.error(res.message);
  }
};

/**
 * 取消收藏
 * @param questionListId
 */
const unCollectQuestion = async (questionListId: number) => {
  const res =
    await QuestionCollectControllerService.deleteQuestionCollectUsingPost({
      questionId: props.id as any,
      questionListId: questionListId,
    });
  if (res.code == 0) {
    await getQuestionCollectByUserAllQuestionListDetail();
    message.success("取消收藏成功");
  } else {
    message.error("取消收藏失败");
  }
};

/**
 * 获取评论列表
 */
const getComments = async () => {
  const res =
    await QuestionCommentControllerService.listQuestionCommentUsingPost(
      commentsSearchParams.value
    );
  if (res.code == 0) {
    comments.value = res.data.result;
    commentNum.value = res.data.commentNum;
    firstCommentNum.value = res.data.total;
  }
};

/**
 * 点击回复或者取消按钮，修改回复框的显示状态
 * @param comment
 */
const toggleReplyBox = (comment: QuestionComment) => {
  comment.showReplyBox = !comment.showReplyBox;
};

/**
 * 发表或者回复评论
 * @param questionId
 * @param parentId
 * @param respondUserId
 */
const publisOrReply = async (
  questionId: number,
  parentId: number,
  respondUserId: number
) => {
  const res =
    await QuestionCommentControllerService.publishQuestionCommentUsingPost({
      questionId: questionId,
      parentId: parentId,
      respondUserId: respondUserId,
      content:
        parentId == 0
          ? replyContent.value
          : respondUserId == 0
          ? firstReplyContent.value
          : secondReplyContent.value,
    });
  if (res.code == 0) {
    await getComments();
    Message.success("回复成功");
    if (parentId == 0) {
      replyContent.value = "";
    } else if (respondUserId == 0) {
      firstReplyContent.value = "";
    } else {
      secondReplyContent.value = "";
    }
  } else {
    Message.error("回复失败：" + res.message);
  }
};

/**
 * 点赞评论
 * @param commmntId
 */
const likeComment = async (commmntId: number) => {
  const res =
    await QuestionCommentControllerService.likeQuestionCommentUsingPost(
      commmntId
    );
  if (res.code == 0) {
    await getComments();
  } else {
    Message.error(res.message);
  }
};

/**
 * 删除评论
 * @param commentId
 */
const deleteComment = async (commentId: number) => {
  const res =
    await QuestionCommentControllerService.deleteQuestionCommentUsingPost({
      id: commentId,
    });
  if (res.code == 0) {
    await getComments();
    Message.success("删除成功");
  } else {
    Message.error("删除失败：" + res.message);
  }
};

/**
 * 举报评论
 * @param commentType 评论类型
 * @param commentId 评论id
 * @param reportedUserId 被举人id
 */
const reportComment = async (
  commentType: number,
  commentId: number,
  reportedUserId: number
) => {
  const res = await CommentReportControllerService.addCommentReportUsingPost({
    commentType: commentType,
    commentId: commentId,
    reportedUserId: reportedUserId,
  });
  if (res.code == 0) {
    Message.success("举报成功");
  } else {
    Message.error("举报失败：" + res.message);
  }
};

/**
 * 获取题解
 */
const getQuestionSolutionList = async () => {
  const res =
    await QuestionSolutionControllerService.listQuestionSolutionByPageUserUsingPost(
      questionSolutionListSearchParams.value
    );
  if (res.code == 0) {
    questionSolutionList.value = res.data.records;
    questionSolutionListTotal.value = res.data.total;
  } else {
    message.error(res.message);
  }
};

/**
 * 创建题解
 */
const addQuestionSolution = async () => {
  const res =
    await QuestionSolutionControllerService.addQuestionSolutionUsingPost(
      addQuestionSolutionForm.value
    );
  if (res.code == 0) {
    message.success("发表成功");
    addQuestionSolutionVisible.value = false;
    await getQuestionSolutionList();
  } else {
    message.error(res.message);
  }
};

/**
 * Tab栏点击事件
 * @param key
 */
const tabClick = (key: string) => {
  if (key == "answers") {
    if (route.path.includes("solution")) {
      // 当在具体题解页面时点击tab栏，就什么都不做
    } else {
      // 如果点击的是题解tab栏就跳转到以下这个路由，然后就会执行onBeforeMount中的判断
      router.push(`${route.path}?tab=answers`);
    }
  }
};

/**
 * 点击题解进行跳转
 * @param questionSolutionId
 */
const goToSolution = (questionSolutionId: number) => {
  router.push({
    path: `/view/question/${props.id}/solution/${questionSolutionId}`,
  });
};

/**
 * 点击头像进行跳转
 * @param userId
 */
const goToUser = (userId: number) => {
  if (userId == loginUser.id) {
    router.push({
      path: `/mine`,
    });
  } else {
    router.push({
      path: `/Ta/${userId}`,
    });
  }
};

router.afterEach((to, from, failure) => {
  // 路由跳转后，如果路径包含answers，就展示题解列表
  if (to.fullPath.includes("answers")) {
    showQuestionSolutionList.value = true;
  } else if (to.fullPath.includes("solution")) {
    // 如果路径包含solution，就不展示题解列表，并显示具体的题解
    showQuestionSolutionList.value = false;
  } else {
    // 否则就刷新页面，因为有可能是跳转到下一道题目
    location.reload();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_icon_file = _resolveComponent("icon-file")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_icon_star_fill = _resolveComponent("icon-star-fill")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_scrollbar = _resolveComponent("a-scrollbar")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_icon_message = _resolveComponent("icon-message")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_IconMessage = _resolveComponent("IconMessage")!
  const _component_IconDelete = _resolveComponent("IconDelete")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icon_exclamation_circle = _resolveComponent("icon-exclamation-circle")!
  const _component_a_collapse_item = _resolveComponent("a-collapse-item")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_icon_code_square = _resolveComponent("icon-code-square")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_overflow_list = _resolveComponent("a-overflow-list")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_icon_history = _resolveComponent("icon-history")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_resize_box = _resolveComponent("a-resize-box")!
  const _component_icon_check_circle_fill = _resolveComponent("icon-check-circle-fill")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_resize_box, {
      directions: ['right'],
      width: resizeBoxWidth.value,
      "onUpdate:width": _cache[9] || (_cache[9] = ($event: any) => ((resizeBoxWidth).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_card, { style: {"height":"93vh"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                "active-key": activeKey.value,
                "onUpdate:activeKey": _cache[8] || (_cache[8] = ($event: any) => ((activeKey).value = $event)),
                size: "mini",
                onTabClick: tabClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, { key: "question" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_file),
                      _createTextVNode(" 题目详情 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_scrollbar, { style: {"height":"calc(100vh - 120px)","overflow":"auto"} }, {
                        default: _withCtx(() => [
                          (question.value)
                            ? (_openBlock(), _createBlock(_component_a_card, {
                                key: 0,
                                title: question.value.title
                              }, {
                                extra: _withCtx(() => [
                                  _createVNode(_component_a_space, { wrap: "" }, {
                                    default: _withCtx(() => [
                                      (isCollect.value)
                                        ? (_openBlock(), _createBlock(_component_icon_star_fill, {
                                            key: 0,
                                            style: {"font-size":"23px","color":"rgb(247, 186, 30)"},
                                            onClick: openQuestionListModal
                                          }))
                                        : (_openBlock(), _createBlock(_component_icon_star_fill, {
                                            key: 1,
                                            style: {"font-size":"23px","color":"rgb(229, 230, 235)"},
                                            onClick: openQuestionListModal
                                          })),
                                      (question.value.isLike)
                                        ? (_openBlock(), _createBlock(_component_IconHeartFill, {
                                            key: 2,
                                            style: {"font-size":"23px","color":"red"},
                                            onClick: likeQuestion
                                          }))
                                        : (_openBlock(), _createBlock(_component_IconHeart, {
                                            key: 3,
                                            style: {"font-size":"23px","color":"gray"},
                                            onClick: likeQuestion
                                          })),
                                      _createTextVNode(" " + _toDisplayString(question.value.likes) + " ", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.tags, (tag, index) => {
                                        return (_openBlock(), _createBlock(_component_a_tag, {
                                          key: index,
                                          color: "gray",
                                          style: {"border-radius":"10px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(tag), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_space, {
                                    direction: "vertical",
                                    size: "large",
                                    fill: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_descriptions, {
                                        title: "判题条件",
                                        column: { xs: 1, md: 2, lg: 3 }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_descriptions_item, { label: "时间限制" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(question.value.judgeConfig.timeLimit) + "ms ", 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_descriptions_item, { label: "内存限制" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(question.value.judgeConfig.memoryLimit) + "KB ", 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(MDViewer, {
                                    value: question.value.content || ''
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["title"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "comment" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_message),
                      _createTextVNode(" 评论 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_scrollbar, { style: {"height":"calc(100vh - 120px)","overflow":"auto"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_comment, {
                            align: "right",
                            avatar: _unref(loginUser).userAvatar
                          }, {
                            actions: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                key: "1",
                                type: "primary",
                                status: "success",
                                shape: "round",
                                disabled: replyContent.value == '',
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (publisOrReply(props.id, 0, 0)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 评论 ")
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            content: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                modelValue: replyContent.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((replyContent).value = $event)),
                                placeholder: "Here is you content."
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["avatar"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (firstComment) => {
                            return (_openBlock(), _createBlock(_component_a_comment, {
                              author: firstComment.userName,
                              content: firstComment.content,
                              datetime: 
                    _unref(moment)(firstComment.createTime).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  
                            }, {
                              avatar: _withCtx(() => [
                                _createVNode(_component_a_avatar, {
                                  onClick: ($event: any) => (goToUser(firstComment.userId)),
                                  size: 32
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: firstComment.userAvatar
                                    }, null, 8, _hoisted_3)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              actions: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: "action",
                                  key: "heart",
                                  onClick: ($event: any) => (likeComment(firstComment.id))
                                }, [
                                  (firstComment.isLike)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                        _createVNode(_component_IconHeart)
                                      ])),
                                  _createTextVNode(" " + _toDisplayString(firstComment.likes), 1)
                                ], 8, _hoisted_4),
                                _createElementVNode("span", {
                                  class: "action",
                                  key: "reply",
                                  onClick: ($event: any) => (toggleReplyBox(firstComment))
                                }, [
                                  _createVNode(_component_IconMessage),
                                  _createTextVNode(" Reply ")
                                ], 8, _hoisted_7),
                                (firstComment.userId == _unref(loginUser).id)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      class: "action",
                                      key: "delete",
                                      onClick: ($event: any) => (deleteComment(firstComment.id))
                                    }, [
                                      _createVNode(_component_a_tooltip, { content: '删除' }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_IconDelete)
                                        ]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_8))
                                  : (_openBlock(), _createElementBlock("span", {
                                      class: "action",
                                      key: "report",
                                      onClick: ($event: any) => (
                        reportComment(1, firstComment.id, firstComment.userId)
                      )
                                    }, [
                                      _createVNode(_component_a_tooltip, { content: '举报' }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_icon_exclamation_circle)
                                        ]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_9))
                              ]),
                              default: _withCtx(() => [
                                (firstComment.showReplyBox)
                                  ? (_openBlock(), _createBlock(_component_a_comment, {
                                      key: 0,
                                      align: "right",
                                      avatar: _unref(loginUser).userAvatar
                                    }, {
                                      actions: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          key: "0",
                                          type: "secondary",
                                          shape: "round",
                                          onClick: ($event: any) => (toggleReplyBox(firstComment))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Cancel ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_a_button, {
                                          key: "1",
                                          type: "primary",
                                          status: "success",
                                          shape: "round",
                                          disabled: firstReplyContent.value == '',
                                          onClick: ($event: any) => (publisOrReply(props.id, firstComment.id, 0))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Reply ")
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"])
                                      ]),
                                      content: _withCtx(() => [
                                        _createVNode(_component_a_input, {
                                          modelValue: firstReplyContent.value,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstReplyContent).value = $event)),
                                          placeholder: "Here is you content."
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["avatar"]))
                                  : _createCommentVNode("", true),
                                (firstComment.childList.length != 0)
                                  ? (_openBlock(), _createBlock(_component_a_collapse, {
                                      key: 1,
                                      "default-active-key": [1],
                                      accordion: "",
                                      bordered: false
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_collapse_item, {
                                          header: firstComment.childList.length + '条回复',
                                          key: "1"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstComment.childList, (secondComment) => {
                                              return (_openBlock(), _createBlock(_component_a_comment, {
                                                author: 
                          secondComment.userName +
                          '' +
                          (secondComment.respondUserId == 0
                            ? ''
                            : ' 回复 ' + secondComment.respondUserName)
                        ,
                                                content: secondComment.content,
                                                datetime: 
                          _unref(moment)(secondComment.createTime).format(
                            'YYYY-MM-DD HH:mm:ss'
                          )
                        
                                              }, {
                                                avatar: _withCtx(() => [
                                                  _createVNode(_component_a_avatar, {
                                                    onClick: ($event: any) => (goToUser(secondComment.userId)),
                                                    size: 32
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("img", {
                                                        src: secondComment.userAvatar
                                                      }, null, 8, _hoisted_10)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                actions: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    class: "action",
                                                    key: "heart",
                                                    onClick: ($event: any) => (likeComment(secondComment.id))
                                                  }, [
                                                    (secondComment.isLike)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                          _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                          _createVNode(_component_IconHeart)
                                                        ])),
                                                    _createTextVNode(" " + _toDisplayString(secondComment.likes), 1)
                                                  ], 8, _hoisted_11),
                                                  _createElementVNode("span", {
                                                    class: "action",
                                                    key: "reply",
                                                    onClick: ($event: any) => (toggleReplyBox(secondComment))
                                                  }, [
                                                    _createVNode(_component_IconMessage),
                                                    _createTextVNode(" Reply ")
                                                  ], 8, _hoisted_14),
                                                  (secondComment.userId == _unref(loginUser).id)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        class: "action",
                                                        key: "delete",
                                                        onClick: ($event: any) => (deleteComment(secondComment.id))
                                                      }, [
                                                        _createVNode(_component_a_tooltip, { content: '删除' }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_IconDelete)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ], 8, _hoisted_15))
                                                    : (_openBlock(), _createElementBlock("span", {
                                                        class: "action",
                                                        key: "report",
                                                        onClick: ($event: any) => (
                              reportComment(
                                1,
                                secondComment.id,
                                secondComment.userId
                              )
                            )
                                                      }, [
                                                        _createVNode(_component_a_tooltip, { content: '举报' }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_icon_exclamation_circle)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ], 8, _hoisted_16))
                                                ]),
                                                default: _withCtx(() => [
                                                  (secondComment.showReplyBox)
                                                    ? (_openBlock(), _createBlock(_component_a_comment, {
                                                        key: 0,
                                                        align: "right",
                                                        avatar: _unref(loginUser).userAvatar
                                                      }, {
                                                        actions: _withCtx(() => [
                                                          _createVNode(_component_a_button, {
                                                            key: "0",
                                                            type: "secondary",
                                                            shape: "round",
                                                            onClick: ($event: any) => (toggleReplyBox(secondComment))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Cancel ")
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"]),
                                                          _createVNode(_component_a_button, {
                                                            key: "1",
                                                            type: "primary",
                                                            status: "success",
                                                            shape: "round",
                                                            disabled: secondReplyContent.value == '',
                                                            onClick: ($event: any) => (
                                publisOrReply(
                                  props.id,
                                  firstComment.id,
                                  secondComment.userId
                                )
                              )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Reply ")
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["disabled", "onClick"])
                                                        ]),
                                                        content: _withCtx(() => [
                                                          _createVNode(_component_a_input, {
                                                            modelValue: secondReplyContent.value,
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((secondReplyContent).value = $event)),
                                                            placeholder: "Here is you content."
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["avatar"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1032, ["author", "content", "datetime"]))
                                            }), 256))
                                          ]),
                                          _: 2
                                        }, 1032, ["header"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["author", "content", "datetime"]))
                          }), 256)),
                          _createVNode(_component_a_pagination, {
                            style: {"position":"relative","top":"5px"},
                            total: firstCommentNum.value,
                            "show-page-size": "",
                            simple: "",
                            "show-total": "",
                            current: commentsSearchParams.value.current,
                            "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((commentsSearchParams.value.current) = $event)),
                            "page-size": commentsSearchParams.value.pageSize,
                            "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((commentsSearchParams.value.pageSize) = $event)),
                            onChange: onCommentsPageChange,
                            onPageSizeChange: onCommentsPageSizeChange
                          }, null, 8, ["total", "current", "page-size"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "answers" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_code_square),
                      _createTextVNode(" 题解 ")
                    ]),
                    default: _withCtx(() => [
                      (showQuestionSolutionList.value)
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            model: questionSolutionListSearchParams.value,
                            layout: "inline",
                            style: {"justify-content":"center"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { field: "tags" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_tag, {
                                    modelValue: questionSolutionListSearchParams.value.tags,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((questionSolutionListSearchParams.value.tags) = $event)),
                                    placeholder: "输入标签",
                                    style: {"width":"200px","border-radius":"10px"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, { field: "title" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_search, {
                                    modelValue: questionSolutionListSearchParams.value.title,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((questionSolutionListSearchParams.value.title) = $event)),
                                    placeholder: "搜索题解",
                                    style: {"width":"200px","border-radius":"10px"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    disabled: question.value.isAccepted == 1,
                                    type: "primary",
                                    shape: "round",
                                    status: "success",
                                    onClick: openAddQuestionSolutionModal
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("发表题解 ")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true),
                      (showQuestionSolutionList.value)
                        ? (_openBlock(), _createBlock(_component_a_list, {
                            key: 1,
                            scrollbar: true,
                            "max-height": 700,
                            size: 'large',
                            data: questionSolutionList.value,
                            "pagination-props": {
                  total: questionSolutionListTotal.value,
                  current: questionSolutionListSearchParams.value.current,
                  pageSize: questionSolutionListSearchParams.value.pageSize,
                  showTotal: true,
                },
                            onPageSizeChange: onQuestionSolutionListPageSizeChange,
                            onPageChange: onQuestionSolutionListPageChange
                          }, {
                            header: _withCtx(() => []),
                            item: _withCtx(({ item }) => [
                              _createVNode(_component_a_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_list_item_meta, {
                                    title: item.title
                                  }, {
                                    avatar: _withCtx(() => [
                                      _createVNode(_component_a_avatar, {
                                        onClick: ($event: any) => (goToUser(item.userId))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            alt: "avatar",
                                            src: item.userAvatar
                                          }, null, 8, _hoisted_17)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    title: _withCtx(() => [
                                      _createVNode(_component_a_typography_text, {
                                        bold: "",
                                        onClick: 
                            () => {
                              showQuestionSolutionList.value = false;
                              goToSolution(item.id);
                            }
                          
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    description: _withCtx(() => [
                                      _createVNode(_component_a_typography_text, {
                                        ellipsis: "",
                                        type: "secondary",
                                        onClick: 
                            () => {
                              showQuestionSolutionList.value = false;
                              goToSolution(item.id);
                            }
                          
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.content), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_a_overflow_list, {
                                        onClick: 
                            () => {
                              showQuestionSolutionList.value = false;
                              goToSolution(item.id);
                            }
                          ,
                                        style: {"width":"500px"},
                                        min: "8",
                                        margin: "8"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.tags), (tag, index) => {
                                            return (_openBlock(), _createBlock(_component_a_tag, {
                                              key: index,
                                              color: "gray",
                                              style: {"border-radius":"10px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(tag), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createElementVNode("span", {
                                        onClick: 
                            () => {
                              showQuestionSolutionList.value = false;
                              goToSolution(item.id);
                            }
                          
                                      }, [
                                        _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } }),
                                        _createTextVNode(" " + _toDisplayString(item.likes), 1)
                                      ], 8, _hoisted_18),
                                      _createElementVNode("span", {
                                        style: {"margin-left":"5px"},
                                        onClick: 
                            () => {
                              showQuestionSolutionList.value = false;
                              goToSolution(item.id);
                            }
                          
                                      }, [
                                        _createVNode(_component_IconMessage),
                                        _createTextVNode(" " + _toDisplayString(item.comments), 1)
                                      ], 8, _hoisted_19)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["data", "pagination-props"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_scrollbar, { style: {"height":"calc(100vh - 120px)","overflow":"auto"} }, {
                        default: _withCtx(() => [
                          (!showQuestionSolutionList.value)
                            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "history" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_icon_history),
                      _createTextVNode(" 提交记录 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_scrollbar, { style: {"height":"calc(100vh - 120px)","overflow":"auto"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_table, {
                            columns: columns,
                            data: dataList.value,
                            pagination: {
                    showTotal: true,
                    current: questionSubmitSearchParams.value.current,
                    pageSize: questionSubmitSearchParams.value.pageSize,
                    total: total.value,
                    showPageSize: true,
                  },
                            onPageChange: onQuestionSubmitPageChange,
                            onPageSizeChange: onQuestionSubmitPageSizeChange,
                            onRowClick: handleHistoryRecordClick
                          }, {
                            message: _withCtx(({ record }) => [
                              (
                        record.judgeInfo.message ===
                        _unref(JudgeInfoMessageEnum).ACCEPTED
                      )
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 0,
                                    color: "blue",
                                    bordered: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (
                        record.judgeInfo.message ===
                        _unref(JudgeInfoMessageEnum).WAITING
                      )
                                  ? (_openBlock(), _createBlock(_component_a_tag, {
                                      key: 1,
                                      color: "green",
                                      bordered: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_a_tag, {
                                      key: 2,
                                      color: "red",
                                      bordered: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                            ]),
                            memory: _withCtx(({ record }) => [
                              _createTextVNode(_toDisplayString(record.judgeInfo.memory ? record.judgeInfo.memory : 0) + " K ", 1)
                            ]),
                            time: _withCtx(({ record }) => [
                              _createTextVNode(_toDisplayString(record.judgeInfo.time ? record.judgeInfo.time : 0) + " ms ", 1)
                            ]),
                            createTime: _withCtx(({ record }) => [
                              _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                            ]),
                            _: 1
                          }, 8, ["data", "pagination"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["active-key"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["width"]),
    _createVNode(_component_a_modal, {
      width: "50%",
      visible: questionListVisible.value,
      placement: "right",
      onCancel: closeQuestionListModal,
      footer: false,
      unmountOnClose: "",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: questionListSearchParams.value,
          layout: "inline",
          style: {"justify-content":"center","align-content":"center","margin":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { field: "title" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  modelValue: questionListSearchParams.value.title,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((questionListSearchParams.value.title) = $event)),
                  placeholder: "搜索题单",
                  style: {"width":"300px","border-radius":"10px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_list, {
          scrollbar: true,
          "max-height": 700,
          size: 'large',
          data: questionList.value,
          "pagination-props": {
          total: questionListTotal.value,
          current: questionListSearchParams.value.current,
          pageSize: questionListSearchParams.value.pageSize,
          showTotal: true,
          showPageSize: true,
        },
          onPageSizeChange: onQuestionListPageSizeChange,
          onPageChange: onQuestionListPageChange
        }, {
          item: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_list_item_meta, {
                  title: item.title
                }, {
                  avatar: _withCtx(() => [
                    (item.isCollect)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 0,
                          content: "取消收藏",
                          onClick: ($event: any) => (unCollectQuestion(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icon_check_circle_fill, {
                              style: { fontSize: '32px', color: 'black' },
                              "stroke-width": 2
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (!item.isCollect)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 1,
                          content: "收藏",
                          onClick: ($event: any) => (collectQuestion(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icon_check_circle_fill, {
                              style: { fontSize: '32px', color: 'gray' },
                              "stroke-width": 2
                            })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["title"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination-props"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      width: "50%",
      visible: addQuestionSolutionVisible.value,
      placement: "right",
      onCancel: closeAddQuestionSolutionModal,
      onOk: addQuestionSolution,
      "ok-text": '创建',
      unmountOnClose: "",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: addQuestionSolutionForm.value,
          "label-align": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "title",
              label: "题解标题",
              tooltip: "请输入标题"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: addQuestionSolutionForm.value.title,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addQuestionSolutionForm.value.title) = $event)),
                  placeholder: "请输入题解标题"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "tags",
              label: "标签",
              tooltip: "请输入标签"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_tag, {
                  modelValue: addQuestionSolutionForm.value.tags,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addQuestionSolutionForm.value.tags) = $event)),
                  placeholder: "请输入标签",
                  "allow-clear": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "content",
              tooltip: "请输入内容",
              label: "题解内容"
            }, {
              default: _withCtx(() => [
                _createVNode(MDEditor, {
                  value: addQuestionSolutionForm.value.content,
                  "hanndle-change": onContentChange
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    (!historyVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "rightPart",
          style: _normalizeStyle({ width: codeWidth.value + 'px' })
        }, [
          _createVNode(_component_a_card, { style: {"height":"93vh"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: form.value,
                layout: "inline",
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    field: "language",
                    style: {"min-width":"240px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            modelValue: form.value.language,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.language) = $event)),
                            style: {"width":"150px","border-radius":"5px"},
                            placeholder: "请选择语言"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                                return (_openBlock(), _createBlock(_component_a_option, { key: language }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(language), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_a_button, {
                            onClick: handleConsoleClick,
                            style: {"width":"66px","height":"28px","border-radius":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 控制台 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            status: "success",
                            style: {"width":"66px","height":"28px","border-radius":"5px"},
                            onClick: doQuestionSubmit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 提交 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(CodeEditor, {
                value: form.value.code as string,
                language: form.value.language as string,
                "hanndle-change": onCodeChange
              }, null, 8, ["value", "language"])
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    (historyVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "history",
          style: _normalizeStyle({ width: codeWidth.value })
        }, [
          _createVNode(_component_a_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "text",
                onClick: _cache[14] || (_cache[14] = 
            () => {
              historyVisible.value = false;
            }
          )
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_icon_close)
                ]),
                _: 1
              }),
              _createVNode(_component_a_space, {
                direction: "vertical",
                size: "large",
                fill: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_descriptions, { column: { xs: 1, md: 2, lg: 3 } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions_item, { label: "语言" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, { color: "arcoblue" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(historyRecord.value.language), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "执行时间" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(historyRecord.value.judgeInfo.time ? historyRecord.value.judgeInfo.time : 0) + " ms ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "消耗内存" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(historyRecord.value.judgeInfo.memory
                  ? historyRecord.value.judgeInfo.memory
                  : 0) + " K ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Codemirror), {
                modelValue: historyRecord.value.code,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((historyRecord.value.code) = $event)),
                style: {"height":"80vh"},
                autofocus: false,
                "indent-with-tab": true,
                "tab-size": 2,
                extensions: extensions,
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      height: 500,
      visible: consoleVisible.value,
      placement: 'bottom',
      "hide-cancel": true,
      "ok-text": '运行',
      "ok-loading": runLoading.value,
      onOk: handleRunClick,
      onCancel: handleConsoleClose,
      "esc-to-close": ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(" 自测运行")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_space, { style: {"display":"flex","justify-content":"center","align-items":"center"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createTextVNode(" 自定义输入： "),
                _createVNode(_component_a_divider),
                _createVNode(_component_a_textarea, {
                  onInput: _cache[16] || (_cache[16] = 
              (value) => {
                runCodeRequest.value.input = value;
              }
            ),
                  style: {"height":"250px","width":"95vh","background-color":"rgba(91, 91, 91, 0)","border":"white"}
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createTextVNode(" 运行结果： "),
                _createVNode(_component_a_divider),
                _createVNode(_component_a_textarea, {
                  modelValue: runCodeResponse.value.output,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((runCodeResponse.value.output) = $event)),
                  style: {"height":"250px","background-color":"rgba(91, 91, 91, 0)","border":"white","width":"95vh"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "ok-loading"])
  ]))
}
}

})